import React from 'react'

const Error = () => {
  return (
    <div className='flex justify-center items-center text-red-700'>
      Error - 404 Page Not Found</div>
  )
}

export default Error